import { render, staticRenderFns } from "./QualificationsRegistryList.vue?vue&type=template&id=30b88844"
import script from "./QualificationsRegistryList.vue?vue&type=script&lang=js"
export * from "./QualificationsRegistryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports